import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-paragraph-icon',
  templateUrl: './text-paragraph.component.html'
})
export class TextParagraphComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
